"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayloadMessage = void 0;
const getPayloadMessage = (unpackedDevicePayload, meta) => {
    const messageBase = {
        state: {
            reported: {
                meta: {},
            },
        },
    };
    if (meta.deviceId) {
        meta.deviceId = meta.deviceId.toUpperCase();
    }
    Object.assign(messageBase.state.reported, unpackedDevicePayload);
    Object.assign(messageBase.state.reported.meta ?? {}, meta);
    return messageBase;
};
exports.getPayloadMessage = getPayloadMessage;
